import type { IconSvgObject } from './types';

const UnfoldLessIcon: IconSvgObject = [
  ["path", { d: "M18 19C18 19 13.5811 14 12 14C10.4188 14 6 19 6 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 5.00004C18 5.00004 13.5811 9.99999 12 10C10.4188 10 6 5 6 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default UnfoldLessIcon;
